<template>
  <div>
    <app-card :product="product" :key="product.slug" v-for="product in products"></app-card>
    <div class="col-md-3 m-0 p-0">
      <div class="image">
        <div class="text-muted text-center default-card">
          <h3>Have an idea for an App? </h3>
          <p>Build your own with the womia APIs.</p>
          <p><a href="/beta/contact-us-developer">Contact us for more info.</a></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppCard from '@/components/AppCard'

export default {
  components: { 'app-card': AppCard },
  name: 'AppList',
  props: ['products']
}
</script>
<style>
.image .default-card {
  background: white;
  height: 300px;
  padding: 50px 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/AppList.vue